import colors from 'vuetify/lib/util/colors'

const gray = Object.freeze({
  900: '#19181A',
  850: '#242126',
  800: '#2E2832',
  700: '#4A464D',
  600: '#646166',
  500: '#7C797F',
  400: '#959199',
  300: '#ADAAB1',
  200: '#CECDD1',
  100: '#DEDEE0',
  50: '#EEEEF0',
  40: '#F4F4F7',
  20: '#F9F9FC',
  white: '#FFFFFF'
})

const brand = Object.freeze({
  700: '#A91DEE',
  500: '#B645EE',
  300: '#CA6CF9',
  200: '#D8ADED',
  100: '#E8C3FA',
  50: '#F4E3FD'
})

const red = Object.freeze({
  700: '#B71921',
  500: '#F5222D',
  300: '#FF8282',
  200: '#F0A3A8',
  100: '#FCB8BC',
  50: '#FEDEE0'
})

const orange = Object.freeze({
  700: '#B76D00',
  500: '#EA9E06',
  300: '#FFD666',
  200: '#F2D69D',
  100: '#F8E0B0',
  50: '#FCF1DA'
})

const blue = Object.freeze({
  700: '#006C9C',
  500: '#18A5E2',
  300: '#5FDBF4',
  200: '#A0D3E8',
  100: '#B6E3F6',
  50: '#DDF2FB'
})

const green = Object.freeze({
  700: '#0F8D57',
  500: '#1AC47A',
  300: '#78ED9F',
  200: '#8BE0BB',
  100: '#B6ECD4',
  50: '#DDF6EB'
})

const lightGreen = Object.freeze({
  300: '#E9FF64'
})

const oldGreen = Object.freeze({
  green: colors.green.base,
  darken1: colors.green.darken1,
  darken2: colors.green.darken2,
  darken3: colors.green.darken3,
  darken4: colors.green.darken4,
  lighten1: colors.green.lighten1,
  lighten2: colors.green.lighten2,
  lighten3: colors.green.lighten3,
  lighten4: colors.green.lighten4,
  lighten5: colors.green.lighten5,
  accent1: colors.green.accent1,
  accent2: colors.green.accent2,
  accent3: colors.green.accent3,
  accent4: colors.green.accent4
})

const oldRed = Object.freeze({
  red: colors.red.base,
  darken1: colors.red.darken1,
  darken2: colors.red.darken2,
  darken3: colors.red.darken3,
  darken4: colors.red.darken4,
  lighten1: colors.red.lighten1,
  lighten2: colors.red.lighten2,
  lighten3: colors.red.lighten3,
  lighten4: colors.red.lighten4,
  lighten5: colors.red.lighten5,
  accent1: colors.red.accent1,
  accent2: colors.red.accent2,
  accent3: colors.red.accent3,
  accent4: colors.red.accent4
})

const oldGrey = Object.freeze({
  darken1: colors.grey.darken1
})

export const lightColors = {
  gray,
  brand,
  red,
  orange,
  blue,
  green,
  lightGreen,
  oldGreen,
  oldRed,
  oldGrey
}
const baseColorsLightByShade = {}

for (const color in lightColors) {
  for (const shade in lightColors[color]) {
    baseColorsLightByShade[`${color}${shade}`] = lightColors[color][shade]
  }
}
export default baseColorsLightByShade
